import { render } from "react-dom";
/**
 * Sample for Line Series
 */
import * as React from "react";
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  LineSeries,
  AreaSeries,
  DateTime,
  Legend,
  Tooltip,
  Category,
} from "@syncfusion/ej2-react-charts";
import { Grid, Box, Typography, Stack } from "@mui/material";
import NoData from "../Nodata";
import { useTranslation } from "react-i18next";
const SAMPLE_CSS = `
   `;
export default function AreaGraph({ graph, tab, selectedTime, selectedKey }) {
  const { t } = useTranslation("common");
  // console.log(selectedTime, "::vlaue::");
  // console.log(tab, "::tab::");
  // console.log(selectedKey, "::selectedKey::");
  const [data, setData] = React.useState([]);
  React.useEffect(() => {
    if (graph) {
      const d = [];
      graph.forEach((g, index) => {
        d.push({ x: g[0], y: g[1] });
      });

      setData([...d]);
    }
  }, [graph]);
  return (
    <div
      // className="control-pane"
      style={{
        margin: "6px",
        // background: "#262626",
        background: "#090909",
        borderRadius: "5px",
        height: tab === "Tips" ? "272px" : "457px",
        position: "relative",
      }}
    >
      <style>{SAMPLE_CSS}</style>
      {data.length > 0 ? (
        <div
          className="control-pane"
          style={{
            margin: "6px",
            // background: "#262626",
            background: "#090909",
            borderRadius: "5px",
            position: "relative",
            top: tab === "Tips" ? "" : "15%",
          }}
        >
          <>
            <div className="control-section">
              <ChartComponent
                background="#090909"
                height={tab === "Tips" ? "250px" : "350px"}
                width="100%"
                id="charts"
                style={{ textAlign: "center" }}
                primaryXAxis={{
                  // labelFormat: "{value}",
                  valueType: "Category",
                  interval: 1,
                  edgeLabelPlacement: "Shift",
                  minimum: 0,
                  // majorGridLines: { width: 0.5 },
                  majorTickLines: { width: 0 },
                  minorTickLines: { width: 0 },
                  majorGridLines: { width: 0 },
                  labelPlacement: "OnTicks",
                  title:
                    selectedKey === "m17"
                      ? t("analytics.barGraph.text1")
                      : selectedKey === "m19"
                      ? t("analytics.barGraph.text3")
                      : selectedKey === "m20"
                      ? t("analytics.barGraph.text4")
                      : "",
                  titleStyle: { size: "18px" },
                  isIndexed: true,
                }}
                primaryYAxis={{
                  labelFormat: "{value}",
                  rangePadding: "None",
                  minimum: 0,
                  majorGridLines: { width: 0.5 },
                  title:
                    tab === "Views"
                      ? t("analytics.card.card1")
                      : tab === "Tips"
                      ? t("analytics.card.card2")
                      : tab === "Streams"
                      ? t("analytics.card.card3")
                      : tab === "Follow"
                      ? t("analytics.card.card4")
                      : "Billions (USD)",
                  titleStyle: { size: "18px" },
                }}
                chartArea={{ border: { width: 0 } }}
                tooltip={{ enable: true }}
                loaded={(args) => {
                  onChartLoad(args);
                }}
              >
                <Inject
                  services={[
                    LineSeries,
                    AreaSeries,
                    DateTime,
                    Category,
                    Legend,
                    Tooltip,
                  ]}
                />
                <SeriesCollectionDirective>
                  <SeriesDirective
                    dataSource={data}
                    xName="x"
                    yName="y"
                    type="Area"
                    fill="url(#gradient-chart)"
                    width={2}
                    marker={{
                      DataLabel: { visible: true },
                      height: 7,
                      width: 7,
                      isFilled: true,
                      visible: true,
                      fill: "black",
                      majorTickLines: { width: 5 },
                      border: { color: "#FFFFFF" },
                    }}
                    border={{ width: 2, color: "white" }}
                  />
                </SeriesCollectionDirective>
              </ChartComponent>
            </div>
            <svg style={{ height: "0" }}>
              <defs>
                <linearGradient id="gradient-chart" x1="0" x2="0" y1="0" y2="1">
                  <stop stopColor="#FFEE20" offset="0%" />
                  <stop stopColor="#FFB715" offset="25%" />
                  <stop stopColor="#FF1CBE" offset="50%" />
                  <stop stopColor="#00C3FD" offset="75%" />
                  <stop stopColor="#62FFE1" offset="100%" />
                </linearGradient>
              </defs>
            </svg>
          </>
        </div>
      ) : (
        <NoData lable={t("noDataToShow")} />
      )}
    </div>
  );

  function onChartLoad(args) {
    let chart = document.getElementById("charts");
    chart.setAttribute("title", "");
  }
}
